module.exports = function(app) {
	app.controller("pages.spending.forms", ["$scope", "$state", "session", "$window", "resourcesList", "spendingResourceServices","coremetrics","aemContentResourceServices",
		function($scope, $state, session, $window, resourcesList, spendingResourceServices, coremetrics,aemContentResourceServices){

		// attach session for pre- and post- password display
		$scope.session = session.data;
		$scope.pagination = {
			page: 1,
			itemsPerPage: '10'
		};

		var benefits, hasDental, hasDrug, hasFSA, hasHSA, hasHRA, hasMedical,
			hasPharmacy, hasSpending, hasVision, hasDirectPay;

		var filterFunction = function(item) {
			if (item && item.sections && item.sections.memberSpendingForms
				&& item.entitlements) {
				if (item.entitlements.hasPrePassword && hasPrePassword) { return true; }
				if (item.entitlements.hasDental && hasDental) { return true; }
				if (item.entitlements.hasDrug && hasDrug) { return true; }
				if (item.entitlements.hasMedical && hasMedical ) { return true; }
				if (item.entitlements.hasPharmacy && hasPharmacy ) { return true; }
				if (item.entitlements.hasSpending && hasSpending ) { return true; }
				if (item.entitlements.hasVision && hasVision ) { return true; }
				if (item.entitlements.hasDirectPay && hasDirectPay) { return true; }
				if (item.entitlements.hasFSA && hasFSA) { return true; }
				if (item.entitlements.hasHSA && hasHSA) { return true; }
				if (item.entitlements.hasHRA && hasHRA) { return true; }
			}
			return false;
		};

		$scope.$watch("sidebar.links", function(newValue, oldValue){
			newValue.forEach(function(item){
				if (item.state === "spending.forms") {
					item.refineTemplate = "spending/forms.appTemplate.html/chmhom/pages/spending/formsRefine";
				}
			});
		});

		$scope.resources = [];
		$scope.$watch("session.loggedIn", function(){

			benefits = session.data.benefits || {};
			hasPrePassword = !!session.loggedIn;
			hasDental = benefits.dental;
			hasDrug = benefits.drug;
			hasFSA = false;
			hasHSA = false;
			hasHRA = false;
			hasMedical = benefits.medical || benefits.medicalActive;
			hasPharmacy = false; // is this different than drug?
			hasSpending = benefits.spending;
			hasVision = benefits.vision;
			hasDirectPay = session.data.directPayIndicator;

			spendingResourceServices.getSpendingAccounts().then(function(response){
				hasFSA = response.hasFSA;
				hasHSA = response.hasHSA;
				hasHRA = response.hasHRA;
			}).then(function(){
				aemContentResourceServices.updateResourcesAsync(resourcesList, filterFunction).then(
					function(resources){
						$scope.resources = resources;
				});

			});
		});

		$scope.download = function(item){
			if (item && item.href) {
				coremetrics.elementTag(item.title, "MEMBER:SPENDING");
				window.open(item.href);
			}
		}
	}]);
};